import isPropControlled from './isPropControlled';
export default function isDateControlled(_ref) {
  let {
    range,
    date,
    startDate,
    endDate
  } = _ref;
  if (range) {
    return isPropControlled(startDate) || isPropControlled(endDate);
  }
  return isPropControlled(date);
}
//# sourceMappingURL=isDateControlled.js.map